import { IContract, IEmployee, ILoadingAndFailure } from '../../types/interfaces'
import { getReq } from '../../utils/requests'
import { ThunkResult } from '../index'
import { mapCurrentUserLoadDetailResponse } from './currentUserHelpers'
import { CURRENT_USER_LOAD_CONTRACT_SHARE_LINK, CURRENT_USER_LOAD_DETAIL } from './currentUserTypes'

/* Load detail */

export interface ICurrentUserLoadDetailPayload extends ILoadingAndFailure {
	record?: IEmployee
}

interface ICurrentUserLoadDetailAction {
	type: CURRENT_USER_LOAD_DETAIL
	payload: ICurrentUserLoadDetailPayload
}

export const currentUserLoadDetail =
	(id: number, onSuccess?: (payload: Omit<ICurrentUserLoadDetailPayload, 'isLoading' | 'isFailure'>) => void, onError?: () => void): ThunkResult<void> =>
	async (dispatch) => {
		try {
			dispatch({ type: CURRENT_USER_LOAD_DETAIL.START })
			const { data } = await getReq(`/api/v1/users/{userID}`, { userID: id })
			const payload = mapCurrentUserLoadDetailResponse(data)
			dispatch({ type: CURRENT_USER_LOAD_DETAIL.DONE, payload })
			if (onSuccess) onSuccess(payload)
		} catch (error) {
			dispatch({ type: CURRENT_USER_LOAD_DETAIL.FAIL })
			if (onError) onError()
		}
	}

/* Load contract share link */

export interface ICurrentUserLoadContractShareLinkPayload extends ILoadingAndFailure {
	contract?: IContract
}

interface ICurrentUserLoadContractShareLinkAction {
	type: CURRENT_USER_LOAD_CONTRACT_SHARE_LINK
	payload: ICurrentUserLoadContractShareLinkPayload
}

export const currentUserLoadContractShareLink =
	(employeeContractId: string, onSuccess?: (payload: IContract) => void, onError?: () => void): ThunkResult<void> =>
	async (dispatch) => {
		try {
			dispatch({ type: CURRENT_USER_LOAD_CONTRACT_SHARE_LINK.START })
			const { data } = await getReq(`/api/v1/contracts/{employeeContractId}/share-link`, { employeeContractId })
			const contract = data.contract || null
			dispatch({ type: CURRENT_USER_LOAD_CONTRACT_SHARE_LINK.DONE, payload: { contract } })
			if (onSuccess && contract) onSuccess(contract)
		} catch (error) {
			dispatch({ type: CURRENT_USER_LOAD_CONTRACT_SHARE_LINK.FAIL })
			if (onError) onError()
		}
	}

/* Actions */

export type ICurrentUserAction = ICurrentUserLoadDetailAction | ICurrentUserLoadContractShareLinkAction
